import React, { useEffect, useState } from "react";
import { Intent } from "@blueprintjs/core";

import { UserAccess, UserHasAccess } from "components/user-access";
import { useParams } from "react-router-dom";
import { JobService } from "services";
import { TyreCheckService } from "services/TyreCheckService";
import { PageRestricted } from "pages/errors/page-restricted";
import { Breadcrumbs } from "components/navigation";
import { NotificationInline, NotificationToaster } from "components/notifications";
import { ShowHide } from "components/layout";
import { DataDisplayTable } from "components/data-display";
import { DateToLocal } from "components/dates";
import axios from 'axios';

export function FailedVisitView(props) {

    const { id } = useParams();
    const requiredAction = ["Fleet:View", "FleetPCN:View", "FleetVIS:View"];
    const canAccessPage = UserHasAccess(requiredAction);
    const [headerSections, setHeaderSections] = useState([]);
    const [loadingData, setLoadingData] = useState(true);
    const [permissionDenied, setPermissionDenied] = useState(false);

    useEffect(() => {

        if (!canAccessPage) {
            return;
        }
        loadJob(id);

    }, [id]);

    function loadJob(jobId) {
        setLoadingData(true);

        axios.all([TyreCheckService.getTyreCheck(jobId), JobService.getJob(jobId)]).then(axios.spread(function (tireCheckResponse, jobResponse) {

            var headers = [
                {
                    header: "Date",
                    value: (
                        <DateToLocal format="DD/MM/YYYY HH:mm">
                            {jobResponse.completedDate}
                        </DateToLocal>
                    ),
                    key: 'completed-date'
                },
                {
                    header: "State",
                    value: jobResponse.state === 'Failed Appointment' ? 'Failed Visit' : jobResponse.state,
                    key: 'state'
                },
                {
                    header: "Auditor",
                    value: jobResponse.assigneeName,
                    key: 'auditor'
                },
                {
                    header: "Reference",
                    value: jobResponse.pubsJobId != null && jobResponse.pubsJobId > 0 ? jobResponse.pubsJobId : jobResponse.jobId,
                    key: 'visit-id'
                },
                {
                    header: "Location",
                    value: tireCheckResponse.data.locationName != null ? tireCheckResponse.data.locationName : '',
                    key: 'location-name'
                }
            ];
            setHeaderSections(headers);

            setLoadingData(false);
        }), () => {
            setPermissionDenied(true);
            NotificationToaster.show(Intent.DANGER, "Could not get details. Please refresh the page.");
        });
    }

    return (
        <UserAccess
            perform={requiredAction}
            yes={() => (
                <ShowHide
                    evaluator={permissionDenied}
                    show={
                        <div className="row">
                            <Breadcrumbs items={props.breadcrumbs} />
                            <NotificationInline
                                allowClose={false}
                                show
                                text="You do not have permission to view this visit"
                                intent="danger"
                            ></NotificationInline>
                        </div>
                    }
                    hide={
                        <div className="row">
                            <Breadcrumbs items={props.breadcrumbs} />
                            <h1>{"Visit Report"}</h1>

                            <DataDisplayTable
                                data={headerSections}
                                displayInRows={false}
                                loading={loadingData}
                            />
                        </div>
                    }
                />
            )}
            no={() => <PageRestricted />}
        />
    );
}
